import { Button, Modal } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import ScribeContentDisplay from "./scribe-content-display";

const ScribeContentModal = ({
  show,
  onHide,
  data,
  isDownloading,
  onDownload,
  onContentSave,
  dataLoad,
}) => {
  const displayRef = useRef();
  const [savingContent, setSavingContent] = useState(false);
  const [contentEditMode, setContentEditMode] = useState(false);
  const [editContent, setEditContent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  useEffect(() => {
    if (data && show) {
      setModalData(data);
    }
  }, [data, show]);
  const saveContent = (id) => {
    setSavingContent(true);
    const url = `${process.env.REACT_APP_API_URL}/scribe-bot-publish`;
    axios
      .put(
        url,
        {
          id: id,
          content: editContent,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      )
      .then(({ data }) => {
        onContentSave(editContent);
        toast.success("Content saved successfully");
      })
      .catch((error) => {
        console.error("Error saving content:", error);
        toast.error("Error saving content");
      })
      .finally(() => {
        setSavingContent(false);
        setContentEditMode(false);
      });
  };
  const questionSave = () => {
    if (displayRef.current) {
      setIsLoading(true);

      displayRef.current.callDisplayFunction();
    }
  };
  const handleHide = () => {
    setContentEditMode(false);
    onHide();
  };

  return (
    <Modal
      show={show && !!modalData}
      onHide={handleHide}
      centered
      dialogClassName="modal-90w"
      style={{ zIndex: 10000 }}
    >
      {!!modalData && (
        <>
          <Modal.Header closeButton>
            <Modal.Title>Generated Content</Modal.Title>
            {modalData.status === "VALIDATION_COMPLETED" && (
              <>
                <Button
                  disabled={!!isDownloading}
                  onClick={() => {
                    onDownload(modalData.is_question == 1 ? "xml" : "txt");
                  }}
                  className="mb-2 ms-4"
                  variant="outline-dark"
                  style={{
                    height: "38px",
                    minHeight: "38px",
                    lineHeight: "14px",
                  }}
                >
                  {isDownloading
                    ? "Downloading"
                    : `Download as ${modalData.is_question == 1 ? "XML" : "TXT"}`}
                </Button>

                {modalData.is_question == 0 ? (
                  <Button
                    disabled={!!savingContent}
                    onClick={() => {
                      if (contentEditMode) {
                        if (editContent.trim().length < 50) {
                          toast.error("Content must be at least 50 characters.");
                          return;
                        } else {
                          saveContent(modalData.id);
                        }
                      } else {
                        setEditContent(modalData.generated_content);
                        setContentEditMode(true);
                      }
                    }}
                    className="mb-2 ms-2"
                    variant={contentEditMode ? "primary" : "outline-dark"}
                    style={{
                      height: "38px",
                      minHeight: "38px",
                      lineHeight: "14px",
                    }}
                  >
                    {contentEditMode
                      ? savingContent
                        ? "Saving Content"
                        : "Save Content"
                      : "Edit Content"}
                  </Button>
                ) : (
                  <Button
                    disabled={!!savingContent}
                    className="mb-2 ms-4"
                    variant="outline-dark"
                    style={{
                      height: "38px",
                      minHeight: "38px",
                      lineHeight: "14px",
                    }}
                    onClick={questionSave}
                  >
                    {savingContent ? "Saving Content" : "Save"}
                  </Button>
                )}
              </>
            )}
          </Modal.Header>
          <Modal.Body style={{ overflowY: "auto", maxHeight: "500px" }}>
            {modalData.error ? (
              <div>Error: {modalData.error}</div>
            ) : modalData.status !== "VALIDATION_COMPLETED" ? (
              <div>Content generation in progress. Please wait</div>
            ) : (
              <>
                {modalData.is_question == 0 && (
                  <>
                    <table
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: "0 8px",
                      }}
                    >
                      <tbody>
                        <tr>
                          <th style={{ minWidth: "200px", verticalAlign: "top" }}>
                            Generated Title
                          </th>
                          <td>{modalData.generated_title}</td>
                        </tr>
                        <tr>
                          <th style={{ minWidth: "200px", verticalAlign: "top" }}>
                            Generated Keywords
                          </th>
                          <td>{modalData.generated_keywords}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div
                      style={{
                        borderBottom: "1px solid #ddd",
                        margin: "24px 0",
                      }}
                    />
                  </>
                )}
                {contentEditMode ? (
                  <div>
                    <p style={{ color: "#d9534f", fontWeight: "500" }}>
                      NOTE: Please edit the content carefully. Do not remove required HTML tags or
                      attributes, and avoid adding invalid or unsupported tags.
                    </p>
                    <textarea
                      value={editContent}
                      onChange={(e) => setEditContent(e.target.value)}
                      style={{ width: "100%", height: "400px" }}
                      disabled={savingContent}
                    />
                  </div>
                ) : (
                  <div style={{ position: "relative" }}>
                    <ScribeContentDisplay
                      generatedContent={modalData.generated_content}
                      questionType={modalData.is_question}
                      id={modalData.id}
                      dataLoad={dataLoad}
                      ref={displayRef}
                      onHide={handleHide}
                      setIsLoading={setIsLoading}
                    />
                    {isLoading && (
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ width: "24px", textAlign: "center" }}>
                          <img src="/images/loader.svg" style={{ width: "20px" }} />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};

export default ScribeContentModal;
